import request from '@/config/axios'

export interface RentalProductVO {
  id?: number
  shopId?: number
  productName: string
  productSubtitle?: string
  categoryId: number
  categoryName?: string
  coverImageUrl?: string
  images?: string
  materialFiles?: string
  minRentPrice?: number
  maxRentPrice?: number
  marketPrice?: number
  deposit?: number
  creditFree?: number
  creditScore?: number
  tags?: string
  specs?: string
  description?: string
  sortNo?: number
  status?: number
  rentCount?: number
  createTime?: string
  /** CMS / 首页运营 */
  promoBar?: string
  promoBarTone?: string
  officialTag?: string
  secureTag?: string
  couponTag?: string
  pricePrefix?: string
  rankText?: string
  channelCodes?: string
  minRentDays?: number
}

export const getProductPage = (params: any) =>
  request.get({ url: '/rental/product/page', params })
export const getProduct = (id: number) =>
  request.get({ url: '/rental/product/get', params: { id } })
export const createProduct = (data: RentalProductVO) =>
  request.post({ url: '/rental/product/create', data })
export const updateProduct = (data: RentalProductVO) =>
  request.put({ url: '/rental/product/update', data })
export const deleteProduct = (id: number) =>
  request.delete({ url: '/rental/product/delete', params: { id } })
export const updateProductStatus = (id: number, status: number) =>
  request.put({ url: '/rental/product/update-status', params: { id, status } })
